// Enum for work sync status
export enum WorkSyncStatusEnum {
  MODIFIED = 'MODIFIED',
  NEW = 'NEW',
  PUBLIC_DOMAIN = 'PUBLIC_DOMAIN',
}

// Main Response Interface
export interface GetWorkUnsynced {
  timestamp: Date;
  status: string;
  data: GetWorkUnsyncedData;
  error: {
    error: string;
    title: string;
    code: string;
    trace: string;
    modal: boolean;
  };
  errors: [
    {
      error: string;
      title: string;
      code: string;
      trace: string;
      modal: boolean;
    },
  ];
  page: number;
  metadata: {
    additionalProp1: any;
    additionalProp2: any;
    additionalProp3: any;
  };
  total_pages: number;
  per_page: number;
  total_items: number;
}

// Params Interface
export interface GetWorkUnsyncedParams {
  page: number;
  size: number;
  sort?: string;
  search?: string;
}

// Data Interface
export interface GetWorkUnsyncedData {
  totalPages: number;
  totalElements: number;
  size: number;
  content: GetWorkUnsyncedItem[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
  };
  first: boolean;
  last: boolean;
  empty: boolean;
}

// Unsynced Work Item Interface
export interface GetWorkUnsyncedItem {
  id: number;
  title: string;
  composerNames: string;
  ecadCode: string;
  iswc: string;
  status: WorkSyncStatusEnum;
  checked?: boolean; // For checkbox selection
}
